import {
  As,
  Box,
  BoxProps,
  Heading,
  HeadingProps,
  List,
  ListItem,
  ListItemProps,
  Text,
  TextProps,
} from "@chakra-ui/react";
import { ListProps } from "@chakra-ui/system";
import parse, {
  DOMNode,
  domToReact,
  HTMLReactParserOptions,
} from "html-react-parser";
export interface HTMLRendererProps {
  htmlElement: string;
  elementProps?:
    | TextProps
    | BoxProps
    | HeadingProps
    | ListProps
    | ListItemProps;
}
function HTMLRenderer({ htmlElement, elementProps }: HTMLRendererProps) {
  const headingSizes: { [key: string]: string } = {
    h1: "xl",
    h2: "lg",
    h3: "md",
    h4: "sm",
    h5: "xs",
    h6: "xs",
  };

  //this is done because chakra ui doesn't have direct support for h4, h5, h6 in Heading component (Shirish)
  const options: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode.type === "tag") {
        const { name, attribs, children } = domNode;
        const newChildren = children as DOMNode[];

        if (["h1", "h2", "h3", "h4", "h5", "h6"].includes(name)) {
          return (
            <Heading
              as={name as As}
              size={headingSizes[name]}
              key={attribs?.id || `${name}-${Math.random()}`}
              {...(elementProps as HeadingProps)}
            >
              {domToReact(newChildren, options)}
            </Heading>
          );
        }

        if (name === "p") {
          return (
            <Text
              as="p"
              key={attribs?.id || `p-${Math.random()}`}
              {...(elementProps as TextProps)}
            >
              {domToReact(newChildren, options)}
            </Text>
          );
        }

        if (name === "strong") {
          return (
            <Box
              as="strong"
              fontWeight="bold"
              key={attribs?.id || `strong-${Math.random()}`}
              {...(elementProps as BoxProps)}
            >
              {domToReact(newChildren, options)}
            </Box>
          );
        }

        if (name === "ul" || name === "ol") {
          return (
            <List
              as={name as "ul" | "ol"}
              styleType={name === "ul" ? "disc" : "decimal"}
              key={attribs?.id || `${name}-${Math.random()}`}
              {...(elementProps as ListProps)}
            >
              {domToReact(newChildren, options)}
            </List>
          );
        }

        if (name === "li") {
          return (
            <ListItem
              key={attribs?.id || `li-${Math.random()}`}
              {...(elementProps as ListItemProps)}
            >
              {domToReact(newChildren, options)}
            </ListItem>
          );
        }
      }
      return undefined;
    },
  };
  return (
    <Box className="prose" as="article" {...(elementProps as BoxProps)}>
      {parse(htmlElement || "", options)}
    </Box>
  );
}

export const HTMLHeadRenderer = ({ htmlElement }: HTMLRendererProps) => {
  return <>{parse(htmlElement)}</>;
};

export default HTMLRenderer;
